// extracted by mini-css-extract-plugin
export default {"dekanatCard":"DekanatKartice_dekanatCard__Yiu9U","dekanatPosition":"DekanatKartice_dekanatPosition__jLZFx"};